import React, { memo } from "react";
import clsx from "clsx";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput } from "components";
import RadioButton from "components/radioButton";
import {
	alphaNumericNormalizer,
	trimMidSentenceNormalizer,
	trimNormalizer,
} from "validators";
import {
	normalizeAll,
	onlyAlphanumericAndSpecialCharacters,
	validateWhenCreditDebitCardTransactionsSettledTypeIsOther,
} from "validators/validation";

import styles from "./businessInfo.module.scss";

const BusinessUnderwritingInfo = ({ formValues }) => {
	const haveAcceptedCardsPreviously =
		formValues?.haveYouAcceptedCardsPreviously === "true";

	return (
		<>
			<div className={clsx(styles.subHeader, "mb-3")}>
				Business Underwriting Info
			</div>
			<Row>
				<Col lg={12}>
					<div className={clsx(styles.addressTitle, "mb-4")}>
						Credit &amp; Debit Card Sales Transactions are Settled
					</div>
					<Row>
						<Col lg={3}>
							<Field
								component={RadioButton}
								value="DateOfOrder"
								className={styles.radioButton}
								name="creditAndDebitCardTransactionsAreSettled"
								label="Date of Order"
								type="radio"
								id="dateOfOrder"
							/>
						</Col>
						<Col lg={3}>
							<Field
								component={RadioButton}
								value="DateOfShipment"
								className={styles.radioButton}
								name="creditAndDebitCardTransactionsAreSettled"
								label="Date of Shipment"
								type="radio"
								id="dateOfShipment"
							/>
						</Col>
						<Col lg={3}>
							<div className={styles.wrappRadioInput}>
								<Field
									component={RadioButton}
									value="Other"
									className={clsx(
										styles.radioButton,
										styles.mr25,
									)}
									name="creditAndDebitCardTransactionsAreSettled"
									label="Other"
									type="radio"
									id="other"
									requiredMark={
										formValues?.creditAndDebitCardTransactionsAreSettled ===
										"Other"
									}
								/>
								<Field
									component={CustomInput}
									type="text"
									disabled={
										formValues?.creditAndDebitCardTransactionsAreSettled !==
										"Other"
									}
									validate={
										validateWhenCreditDebitCardTransactionsSettledTypeIsOther
									}
									normalize={normalizeAll([
										onlyAlphanumericAndSpecialCharacters,
										trimMidSentenceNormalizer,
									])}
									name="creditDebitCardTransactionsAreSettledTypeIfOther"
									normalizeOnBlur={trimNormalizer}
									smSelect={12}
								/>
							</div>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row>
				<Col lg={12}>
					<div className={`${styles.addressTitle} ${`mb-4`}`}>
						Selling Outside of US?
					</div>
					<div className={styles.wrappRadio}>
						<Field
							component={RadioButton}
							value="false"
							className={styles.radioButton}
							name="sellingOutsideOfUS"
							label="No"
							type="radio"
							id="noSellingOutside"
						/>
						<Field
							component={RadioButton}
							value="true"
							className={styles.radioButton}
							name="sellingOutsideOfUS"
							label="Yes"
							type="radio"
							id="yesSellingOutside"
						/>
					</div>
				</Col>
			</Row>
			<Row>
				<Col lg={12} className="mt-2">
					<div className={`${styles.addressTitle} ${`mb-4`}`}>
						Have You Accepted Cards Previously?
					</div>
					<div className={styles.wrappRadio}>
						<Field
							component={RadioButton}
							value="true"
							className={styles.radioButton}
							name="haveYouAcceptedCardsPreviously"
							label="Yes"
							type="radio"
							id="yesAcceptedCards"
						/>
						<Field
							component={RadioButton}
							value="false"
							className={styles.radioButton}
							name="haveYouAcceptedCardsPreviously"
							label="No"
							type="radio"
							id="noAcceptedCards"
						/>
					</div>
				</Col>
			</Row>
			<Row className="mt-2">
				<Col lg={5}>
					<Field
						component={CustomInput}
						type="text"
						label="Previous Account / MID Number"
						labelClassName="py-0"
						disabled={!haveAcceptedCardsPreviously}
						name="previousAccountMIDNumber"
						normalize={alphaNumericNormalizer}
						normalizeOnBlur={trimNormalizer}
						hideRequiredMark
					/>
				</Col>
				<Col lg={{ span: 5, offset: 2 }}>
					<Field
						component={CustomInput}
						type="text"
						label="Who was Your Previous Processor?"
						labelClassName="py-0"
						disabled={!haveAcceptedCardsPreviously}
						name="whoWasPreviousProcessor"
						hideRequiredMark
						normalizeOnBlur={trimNormalizer}
						normalize={normalizeAll([
							onlyAlphanumericAndSpecialCharacters,
							trimMidSentenceNormalizer,
						])}
					/>
				</Col>
			</Row>
		</>
	);
};

export default memo(BusinessUnderwritingInfo);
